/*** IMPORTS FROM imports-loader ***/
var define = false;

// eslint-disable-next-line strict
export default null;

